/**
 * CoevaluationUserContainer Component
 *
 * Features:
 * - Manages the view between coevaluation instructions and user activities.
 * - Uses useState to toggle between instructions and activities.
 * - Passes necessary props to child components for evaluation logic.
 */
import { useState } from 'react';
import PropTypes from 'prop-types';

import CoevaluationInstructions from './CoevaluationInstructions/CoevaluationInstructions';
import CoevaluationsUsers from './CoevaluationsUsers/CoevaluationsUsers';

const CoevaluationUserContainer = props => {
  // State to toggle between instructions and activities view
  const [instructionsView, setInstructionsView] = useState(true);

  const changeViewHandler = () => {
    setInstructionsView(!instructionsView);
  };

  return (
    <>
      {instructionsView && (
        /* Props passed to CoevaluationInstructions:
            - changeViewHandler: changeViewHandler (function to toggle view)
        */
        <CoevaluationInstructions
          changeViewHandler={changeViewHandler}
        />
      )}
      {!instructionsView && (
        /* Props passed to CoevaluationsUsers:
            - changeViewHandler: changeViewHandler (function)
            - idCourse: props.idCourse (number)
            - idLesson: props.idLesson (number)
            - changeCoevaluationStatus: props.changeCoevaluationStatus (function)
        */
        <CoevaluationsUsers
          changeViewHandler={changeViewHandler}
          idCourse={props.idCourse}
          idLesson={props.idLesson}
          changeCoevaluationStatus={props.changeCoevaluationStatus}
        />
      )}
    </>
  );
};

CoevaluationUserContainer.propTypes = {
  /**
   * Course ID
   */
  idCourse: PropTypes.number,
  /**
   * Lesson ID
   */
  idLesson: PropTypes.number,
  /**
   * Function to change coevaluation status
   */
  changeCoevaluationStatus: PropTypes.func
};

CoevaluationUserContainer.defaultProps = {
  idCourse: null,
  idLesson: null,
  changeCoevaluationStatus: () => {}
};

export default CoevaluationUserContainer;
